import domUtils from 'utils/domUtils'

export default {
  playBeep() {
    const audioEl = document.createElement('audio')
    audioEl.setAttribute(
      'src',
      'https://tablelist-assets.s3.amazonaws.com/www-2/tablelist-pro/chat-pling.wav'
    )

    document.body.appendChild(audioEl)

    audioEl.play()

    setTimeout(() => {
      domUtils.removeElement(audioEl)
    }, 1000)
  },
}



// WEBPACK FOOTER //
// ./src/lib/sounds.js